export class loginViewController {
    errMessageCode: string;
    errMessage: string;
    ajaxLoading: boolean;
    activeTab: any = 'login';
    returnUrl;
    title: any = "ورود به حساب کاربری"
    constructor(private $state, private $location: ng.ILocationService, private $mdDialog: ng.material.IDialogService, private $user,private $window:ng.IWindowService) {
        "ngInject"

    }
    $onInit() {
        let regExp = new RegExp("https?://([a-zA-z._<>:0-9]*)/")
        this.returnUrl = this.$location.absUrl().replace(regExp, '/')
    }

    setActiveTab(val) {
        if (val == 'login') {
            this.title = "ورود به حساب کاربری"
        }
        else {
            this.title = "ثبت نام در سایت"
        }
        this.activeTab = val;
    }

    loginViaGoogle() {
        this.ajaxLoading = true;
        this.$user.loginViaGoogle(this.returnUrl)
    }

    registerViaGoogle() {
        this.ajaxLoading = true;
        this.$user.loginViaGoogle(this.returnUrl)
    }

    doRegister(user) {
        this.ajaxLoading = true;
        this.$user.register(user).then(Response => {
            console.log(Response.data);
            this.ajaxLoading = false;
            this.errMessage = Response.data.ResultString
            if (Response.data.ResultCode == 13) {
                this.errMessage = null
                this.$mdDialog.hide(Response.data)
                this.$window.location.reload();
            }
        }).catch(err => {
            this.ajaxLoading = false;
            console.error(err)
        })
    }

    doLogin(user) {
        this.ajaxLoading = true;
        this.$user.login(user).then(Response => {
            if (Response.data) {
                this.$mdDialog.hide(Response.data)
                this.$window.location.reload();
            }
            else {
                this.ajaxLoading = false;
                this.errMessage = "user or password is incorrect"
            }
        })
    }

    close() {
        this.$mdDialog.cancel()
    }
}



// WEBPACK FOOTER //
// ./src/components/login-view/login-view.controller.ts